import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import { cn } from '@/lib/utils';

/**
 * The Sales sub-navigation: Invoices (SAL-04), Quotations (SAL-01), Sales
 * Orders (SAL-02), Delivery Notes (SAL-03 — the document-integration wave),
 * Sales Returns (SAL-05). POS (SAL-06) is its own standalone screen.
 */
const TABS = [
  { to: '/sales', end: true, key: 'sales.tabInvoices' },
  { to: '/sales/quotes', end: false, key: 'sales.tabQuotes' },
  { to: '/sales/orders', end: false, key: 'sales.tabOrders' },
  { to: '/sales/deliveries', end: false, key: 'sales.tabDeliveries' },
  { to: '/sales/returns', end: false, key: 'sales.tabReturns' },
] as const;

export function SalesTabs() {
  const { t } = useTranslation();
  return (
    <nav className="flex flex-wrap gap-1 border-b pb-px" aria-label={t('shell.navSales')}>
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          className={({ isActive }) =>
            cn(
              'rounded-t-md px-3 py-2 text-sm font-medium text-muted-foreground hover:text-foreground',
              isActive && 'border-b-2 border-primary text-foreground',
            )
          }
        >
          {t(tab.key)}
        </NavLink>
      ))}
    </nav>
  );
}
